<template>
  <gj-modal
    v-bind="$attrs"
    v-on="$listeners"
    size="normal"
    padding20
    :visible.sync="modalVisible"
    :confirmLoading="confirmLoading"
    @cancel="cancel"
    @confirm="confirm"
  >
    <template #header>编辑标签分类</template>
    <template #content>
      <el-form ref="form" :model="form" label-width="135px">
        <el-form-item
          label="分类名称"
          prop="name"
          :rules="[
            {
              required: true,
              message: '请输入标签名称',
              trigger: ['blur', 'change'],
            },
          ]"
        >
          <gj-input v-model="form.name" width="250px" placeholder="请输入分类名称"></gj-input>
        </el-form-item>
        <el-form-item label="上级分类" prop="parentId">
          <gj-tree-select
            v-model="form.parentId"
            :data="treeData"
            :clearable="false"
            width="250px"
            placeholder="请选择上级分类"
          ></gj-tree-select>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
import { modalMixIn, formRuleMixin ,responseMixin} from "../../../../../minxins";
import { StatusEnum } from "../common/enum";
import { tagCategoryUpdate, getTagTreeList } from "../../../../../api/system";

export default {
  name: "app-tag-group-edit-modal",
  mixins: [modalMixIn, formRuleMixin,responseMixin],
  props: {
    tag: {
      type: Object,
    },
  },
  data() {
    return {
      confirmLoading: false,
      form: {
        name: null,
        parentId: null,
      },
      treeData: [],
      StatusEnum: StatusEnum,
    };
  },
  created() {
    this.form.name = this.tag.label;
    this.form.parentId = this.tag.fid;
    this.queryData();
  },
  methods: {
    queryData() {
      this.loading = true;
      getTagTreeList()
        .then((res) => {
          this.treeData = res.data;
        })
        .complete(() => (this.loading = false));
    },
    confirm() {
      if (this.$gjFormValidate()) {
        this.confirmLoading = true;
        const params={
          fid:this.form.parentId,
          name:this.form.name,
          level:this.tag.level,
          id:this.tag.id
        }
        tagCategoryUpdate(params)
        .then(res=>{
          this.$gjResponseHandle(res, () => {
              this.$gjMessage.success("编辑标签分类成功");
              this.$emit("created");
              this.$gjDestroy();
            });
        })
        .complete(()=>{this.confirmLoading=false})
      }
    },
  },
};
</script>

<style scoped>
</style>

